import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { Column, Row, Section } from "@react-email/components";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { useTopBlockStyles } from "../../../Design/useTopBlockStyles";
import { SectionContainer } from "../../../Utils/SectionContainer";
import { defaultStyles } from "./defaultStyles";

export interface HeroBlock4Props extends ComponentPropsWithRef<"table"> {
  headerContent?: ReactNode;
  imageContent?: ReactNode;
  primaryButton?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HeroBlock4 = forwardRef<HTMLTableElement, HeroBlock4Props>(
  (
    { headerContent, primaryButton, styles = {}, imageContent, ...rest },
    ref,
  ) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles,
        ignoreDefaults: false,
      },
    );

    return (
      <SectionContainer cssProperties={marginStyles}>
        <Section
          ref={ref}
          style={{
            ...backgroundStyles,
            ...paddingStyles,
            textAlign: "center",
          }}
          {...rest}
        >
          <Row>
            <Column>{headerContent}</Column>
          </Row>

          <Row>
            <Column>
              <BlockSection.NestedBlock>
                {primaryButton}
              </BlockSection.NestedBlock>
            </Column>
          </Row>

          <Row>
            <Column>{imageContent}</Column>
          </Row>
        </Section>
      </SectionContainer>
    );
  },
);

HeroBlock4.displayName = "HeroBlock4";
